import { useState } from 'react';
import { useAppData } from '../context/AppDataContext.jsx';
import MedIntakeRow from '../components/MedIntakeRow.jsx';

export default function MedicationsPage() {
  const { meds, todayMeds, addMed, updateMed, deleteMed, seedDefaultMeds } = useAppData();
  const today = new Date().toISOString().slice(0, 10);

  const [form, setForm] = useState({ name: '', dose: '', notes: '', times: '' });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  async function onSubmit(e) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      const times = form.times
        ? form.times.split(',').map((s) => s.trim()).filter(Boolean)
        : [];
      await addMed({
        name: form.name,
        dose: form.dose,
        notes: form.notes,
        schedule: times.length ? { times } : null,
        active: true,
      });
      setForm({ name: '', dose: '', notes: '', times: '' });
    } catch (ex) {
      setErr(ex.message);
    } finally {
      setBusy(false);
    }
  }

  async function toggleActive(med) {
    await updateMed(med.id, { active: !med.active });
  }

  return (
    <div>
      <div className="card">
        <h2>Oggi · {today}</h2>
        {todayMeds.items.length === 0 ? (
          <p className="muted">Aggiungi le tue medicine qui sotto per vederle qui.</p>
        ) : (
          <div>
            {todayMeds.items.map(({ med, intakes }) => (
              <MedIntakeRow key={med.id} med={med} intakes={intakes} date={today} />
            ))}
          </div>
        )}
      </div>

      <div className="card">
        <h2>Aggiungi medicina</h2>
        {err && <div className="error">{err}</div>}
        <form onSubmit={onSubmit}>
          <div className="field">
            <label>Nome *</label>
            <input
              required
              placeholder="es. Naprossene"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />
          </div>
          <div className="field">
            <label>Dose</label>
            <input
              placeholder="es. 500mg"
              value={form.dose}
              onChange={(e) => setForm({ ...form, dose: e.target.value })}
            />
          </div>
          <div className="field">
            <label>Orari promemoria (HH:MM separati da virgola, opzionale)</label>
            <input
              placeholder="es. 08:00, 20:00"
              value={form.times}
              onChange={(e) => setForm({ ...form, times: e.target.value })}
            />
          </div>
          <div className="field">
            <label>Note</label>
            <input
              value={form.notes}
              onChange={(e) => setForm({ ...form, notes: e.target.value })}
            />
          </div>
          <button type="submit" disabled={busy}>
            {busy ? 'Salvataggio…' : 'Aggiungi'}
          </button>
        </form>
      </div>

      <div className="card">
        <h2>Tutte le medicine</h2>
        {meds.length === 0 ? (
          <>
            <p className="muted">Nessuna medicina ancora aggiunta.</p>
            <button className="secondary" onClick={() => seedDefaultMeds()}>
              Aggiungi medicine di default (Oki, Tachipirina, Brufen, Ketodol)
            </button>
          </>
        ) : (
          <ul className="list">
            {meds.map((m) => (
              <li key={m.id}>
                <div className="row" style={{ justifyContent: 'space-between' }}>
                  <div>
                    <strong>{m.name}</strong>
                    {m.dose && <> · {m.dose}</>}
                    {!m.active && <span className="muted"> (disattivata)</span>}
                    {m.schedule?.times?.length > 0 && (
                      <div className="muted">
                        Promemoria: {m.schedule.times.join(', ')}
                      </div>
                    )}
                    {m.notes && <div className="muted">{m.notes}</div>}
                  </div>
                  <div className="row">
                    <button className="secondary" onClick={() => toggleActive(m)}>
                      {m.active ? 'Disattiva' : 'Attiva'}
                    </button>
                    <button
                      className="danger"
                      onClick={() => {
                        if (window.confirm(`Eliminare ${m.name}?`)) deleteMed(m.id);
                      }}
                    >
                      Elimina
                    </button>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
